import { TReduxActions } from '../../actions';
import { EMlSearchSessionGuidActionType } from '../../actions/mlSearchSessionGuid';
const initialState = null;

export function mlSearchSessionGuidReducer(state: string | null = initialState, action: TReduxActions): string | null {
  switch (action.type) {
    case EMlSearchSessionGuidActionType.Set:
      return action.payload;
    default:
      return state;
  }
}
